import { Severities } from 'src/app/components/severities-cell/severities-cell.component';

export enum SensitiveDataType {
  SNIPPET = 'SNIPPET',
  TOOL_INVOCATION_PARAMS = 'TOOL_INVOCATION_PARAMS',
  TOOL_INVOCATION_RESULT = 'TOOL_INVOCATION_RESULT',
  SOURCE = 'SOURCE',
}

export type SensitiveDataSnippet = {
  type: SensitiveDataType.SNIPPET;
};

export type AnyResourceId = '***';
export type SensitiveDataToolInvocationParams = {
  type: SensitiveDataType.TOOL_INVOCATION_PARAMS;
  resourceId?: string | AnyResourceId;
};

export type SensitiveDataToolInvocationResult = {
  type: SensitiveDataType.TOOL_INVOCATION_RESULT;
  resourceId?: string | AnyResourceId;
};

export type SensitiveDataSource = {
  type: SensitiveDataType.SOURCE;
  fileName: string;
};

export interface ActivityMessage {
  key: string;
  value?: string | null;
  isCopyable?: boolean;
  copyableText?: string;
  tooltipLabelPath?: string;
  tooltipIconPath?: string;
  iconPath?: string;
  method?: () => void;
  sensitiveData?:
    | SensitiveDataSnippet
    | SensitiveDataToolInvocationParams
    | SensitiveDataToolInvocationResult
    | SensitiveDataSource;
  relatedFindings?: Severities;
}
